<template>
  <div class="container">
      <h2>Página no encontrada</h2>
  </div>
</template>

<script>
export default {
    name:'404'
}
</script>

<style>

</style>